module.exports = __webpack_public_path__ + "img/132-bosnia-and-herzegovina.f02ca102.svg";